import envSelector from "~/lib/envSelector";

export default function (app) {
  const envSelectorObj = envSelector.setEnvironment(app);

  app.config.globalProperties.envSelector = envSelectorObj;
  app.provide("envSelector", envSelectorObj);
}
